import { createApi } from '@reduxjs/toolkit/query/react';
import axiosFetchBase from '../axiosFetchBase.js';
import { urls } from '../../utils/helpers/ApiClient.jsx';

export const translationApi = createApi({
  reducerPath: 'translationApi',
  baseQuery: axiosFetchBase,
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    translateTexts: builder.mutation({
      query: ({ texts, targLang, srcLang, provider }) => ({
        url: urls.translate,
        method: 'POST',
        data: {
          texts: texts,
          targetLang: targLang,
          sourceLang: srcLang,
          provider: provider,
        },
      }),
    }),
    getAllProviders: builder.query({
      query: () => ({
        url: urls.traslationProviders,
        method: 'GET',
      }),
    }),
    getProviderUsage: builder.mutation({
      query: ({ provider }) => ({
        url: urls.providerUsage,
        method: 'POST',
        data: { provider },
      }),
    }),
  }),
});

export const {
  useTranslateTextsMutation,
  useGetAllProvidersQuery,
  useGetProviderUsageMutation,
} = translationApi;
